import React, { useState, useEffect, useContext } from 'react'
// ROUTER
import { useLocation } from 'react-router-dom'
// FIREBASE
import useFirebase from '../../../firebase/useFirebase'
// APP CONTEXT
import { AppContext } from '../../../App'
// HEADER
import HeaderReturn from './../../../components.js/serveur/siteWeb/HeaderReturn'
// SPINNER
import Spinner from '../../../components.js/elements/Spinner'
import useForm from '../../../hooks/useForm'
// IMAGES
import imageRond1 from '../../../images/rond1.png'
import imageRond1ok from '../../../images/rond1ok.png'
import imageRond2 from '../../../images/rond2.png'
import imageRond2ok from '../../../images/rond2ok.png'
import imageRond3 from '../../../images/rond3.png'
import imageRond3ok from '../../../images/rond3ok.png'
import imageRond4 from '../../../images/rond4.png'
import imageRond4ok from '../../../images/rond4ok.png'
import imageRond5 from '../../../images/rond5.png'
import imageRond5ok from '../../../images/rond5ok.png'
import imageIconTelephone from '../../../images/iconTelephone.png'
import ButtonShadow from '../../../components.js/elements/ButtonShadow'
import InputShadow from '../../../components.js/elements/InputShadow'

const INITIAL_STATE = {
    nameStaff:'',
    surnameStaff:'',
    circleColor:'',
    emailStaff:'jklmlkj',
}

const ProfilStaff = () => {
    const { user } = useContext(AppContext)
    const [montage, setMontage] = useState(true)
    const { updateData, writeData, readStaffDatesOff, deleteData, readData, staff, datesOff } = useFirebase() 
    const { handleChange, values, refresh, setValues } = useForm(INITIAL_STATE)
    const location = useLocation()
    const { state } = location

    useEffect(() => {
        readData(user.uid)
        window.scrollTo(0, 0)
        setMontage(false)
    },[]) 

    useEffect(() => {
        if (staff) {
            staff.filter(p => p.id === state.idStaff).map(p => (
                setValues(prev => ({
                    ...prev,
                    surnameStaff:p.surnameStaff,
                    nameStaff:p.nameStaff,
                    circleColor:p.circleColor,
                    phoneStaff:p.phoneStaff,
                }))
            ))
        }
    },[staff])

    if (montage) return <Spinner /> 

    const _updateProfil = () => {
        const data = { 
            surnameStaff:values.surnameStaff ? values.surnameStaff : '',
            nameStaff:values.nameStaff ? values.nameStaff : '',
            phoneStaff:values.phoneStaff ? values.phoneStaff : '',
        }
        updateData('entreprises/'+user.uid+'/staff/'+state.idStaff,data)
    }

    const _updateProfilCircleColor = (number) => {
        const data = {
            circleColor:number
        }
        updateData('entreprises/'+user.uid+'/staff/'+state.idStaff,data)
    }

    const _createConnexion = () => {
        console.log('Staff _createConnexion ', values.emailStaff)
    }

    return (
        <div className='container-fluid'> 

            {/* HEADER */}
            <HeaderReturn title={'Profil ' + state.surnameStaff +' ' + state.nameStaff} link='/staff'/>

            {staff.filter(st => st.id === state.idStaff).map(st => (
                <div key={st.id}>

                    {/* INPUT SURNAME NAME */}
                    <div className='mt-5'>
                        <input type="text" className='form-control border-0 rounded-pill shadow' value={values.surnameStaff} name='surnameStaff' onChange={handleChange} placeholder={st.surnameStaff} />
                    </div> 

                    {/* INPUT SURNAME NAME */}
                    <div className='mt-3'>
                        <input type="text" className='form-control border-0 rounded-pill shadow' value={values.nameStaff} name='nameStaff' onChange={handleChange} placeholder={st.nameStaff} />
                    </div>

                    {/* INPUT PHONE */}
                    <div className='mt-3'>
                        <div className="input-group rounded-pill shadow">
                            <span 
                                className="bg-white border-0 rounded-pill" 
                                style={{ marginLeft:'1rem', paddingTop:'0.2rem'}}
                            >
                                <img 
                                    src={imageIconTelephone} 
                                    alt='image du logo' 
                                    style={{ height:20, width:20, marginTop:'0.2rem' }} 
                                />
                            </span>
                            <input type="text" className='form-control border-0' value={values.phoneStaff} name='phoneStaff' onChange={handleChange} placeholder={st.phoneStaff} />
                            <span 
                                className="bg-white border-0 rounded-pill" 
                                style={{ marginRight:'1rem', paddingTop:'0.2rem', height:20, width:20 }}
                            >
                            </span>
                        </div>
                    </div>

                    {/* BUTTON UPDATE */}
                    <div className='mt-3' />
                    <ButtonShadow title='Modifier' disabled={values.surnameStaff && values.surnameStaff ? false : true} onClick={_updateProfil} />

                    {/* BOX COLORS */}
                    <div className='row mt-3 ms-1'>
                        <div className='col-2' onClick={() => _updateProfilCircleColor('7ddbd3ff')}>
                            {values.circleColor === '7ddbd3ff' ? 
                                <img src={imageRond1ok} alt='image couleur' style={{ height:45, width:45 }} />
                            : 
                                <img src={imageRond1} alt='image couleur' style={{ height:45, width:45 }} />
                            }
                            
                        </div>
                        <div className='col-2' onClick={() => _updateProfilCircleColor('cf92e1ff')}>
                            {values.circleColor === 'cf92e1ff' ? 
                                <img src={imageRond2ok} alt='image couleur' style={{ height:45, width:45 }} />
                            : 
                                <img src={imageRond2} alt='image couleur' style={{ height:45, width:45 }} />
                            }
                        </div>
                        <div className='col-2' onClick={() => _updateProfilCircleColor('f6e2e5ff')}>
                            {values.circleColor === 'f6e2e5ff' ? 
                                <img src={imageRond3ok} alt='image couleur' style={{ height:45, width:45 }} />
                            : 
                                <img src={imageRond3} alt='image couleur' style={{ height:45, width:45 }} />
                            }
                        </div>
                        <div className='col-2' onClick={() => _updateProfilCircleColor('f3bd6aff')}>
                            {values.circleColor === 'f3bd6aff' ? 
                                <img src={imageRond4ok} alt='image couleur' style={{ height:45, width:45 }} />
                            : 
                                <img src={imageRond4} alt='image couleur' style={{ height:45, width:45 }} />
                            }
                        </div>
                        <div className='col-2' onClick={() => _updateProfilCircleColor('f1705fff')}>
                            {values.circleColor === 'f1705fff' ? 
                                <img src={imageRond5ok} alt='image couleur' style={{ height:45, width:45 }} />
                            : 
                                <img src={imageRond5} alt='image couleur' style={{ height:45, width:45 }} />
                            }
                        </div>
                    </div>

                    {/* OPTION CONNEXION */}
                    <div className='mt-4 border-top row' />

                    {/* TITRE */}
                    <div className='text-center mt-3'>OPTION CONNEXION</div>

                    {st.connexion ? 
                        <div>
                            <div>oui il y a une connexion</div>
                        </div>
                    : 
                        <div>
                            {/* ESPACE CONNEXION */}
                            <div>Créer une connexion pour {st.surnameStaff} {st.nameStaff}</div>

                            {/* INPUT EMAIL + PASSWORD */}
                            <InputShadow placeholder='Email' value={values.emailStaff} onChange={handleChange} name='emailStaff' />
                            <div className='mt-3'>Mot de passe : 123456</div>

                            {/* BUTTON SAVE SPACE CONNEXION */}
                            <ButtonShadow title='Enregistrer' onClick={_createConnexion} />
                        </div>

                    }
                </div>
            ))}

        </div>
    )
}

export default ProfilStaff